import store from '../store'
const $ = kendo.jQuery

function getStoreParameters() {
  const {
    'authentication/tokenString': tokenString,
    'authentication/isLoggedIn': isLoggedIn,
    'authentication/selectedClientId': clientId,
  } = store.getters

  return {tokenString, isLoggedIn, clientId}
}

export function getExportExcelLink(grid, actionUrl) {
  const requestObject = new kendo.data.transports['aspnetmvc-server']({
    prefix: '',
  }).options.parameterMap({
    page: grid.dataSource.page(),
    sort: grid.dataSource.sort(),
    filter: grid.dataSource.filter(),
  })

  const data = grid.dataSource.options.transport.read.data
  const additionalFilters = !data ? '' : $.isFunction(data) ? data() : data
  let newHref = actionUrl

  newHref = newHref + '?page=' + (requestObject.page || '1')
  newHref = newHref + '&amp;&sort=' + (requestObject.sort || '~')
  newHref = newHref + '&amp;&filter=' + (requestObject.filter || '~')
  newHref = !additionalFilters
    ? newHref
    : newHref + '&' + $.param(additionalFilters).replace(/%5B%5D=/g, '=')

  const {tokenString, isLoggedIn} = getStoreParameters()
  if (isLoggedIn) {
    newHref = newHref + '&t=' + tokenString
  }

  return newHref
}

export function enableExportExcel(grid, actionUrl, gridToolbar) {
  gridToolbar = gridToolbar || grid.element.find('.k-grid-toolbar')
  $(
    "<a class='exportToExcel k-button k-button-icon' href='' title='Export To Excel'><i class='k-icon k-i-excel'></i></a>",
  )
    .appendTo(gridToolbar)
    .click(function(e) {
      e.preventDefault()
      location.href = getExportUrl(actionUrl, grid)
    })
}

function getExportUrl(actionUrl, grid) {
  let requestObject = new kendo.data.transports['aspnetmvc-server']({
    prefix: '',
  }).options.parameterMap({
    page: grid.dataSource.page(),
    sort: grid.dataSource.sort(),
    filter: grid.dataSource.filter(),
  })

  let data = grid.dataSource.options.transport.read.data
  let additionalFilters = !data ? '' : typeof data == 'function' ? data() : data
  let newHref = actionUrl

  newHref = newHref + '?page=' + (requestObject.page || '1')
  newHref = newHref + '&amp;&sort=' + (requestObject.sort || '~')
  newHref = newHref + '&amp;&filter=' + (requestObject.filter || '~')
  newHref = !additionalFilters
    ? newHref
    : newHref + '&' + $.param(additionalFilters).replace(/%5B%5D=/g, '=')

  const {tokenString, isLoggedIn, clientId} = getStoreParameters()
  if (clientId) {
    newHref = newHref + '&clientId=' + clientId
  }

  if (isLoggedIn) {
    newHref = newHref + '&t=' + tokenString
  }

  return newHref
}

export function enableCustomExportExcel(toolbar, actionUrl) {
  $(`<a class="exportToExcel k-button k-button-icontext' href="#" title="Export To Excel">
       <i class="k-icon k-i-excel"></i>
     </a>`)
    .on('click', () => {
      const {tokenString} = getStoreParameters()
      location.href = `${actionUrl}&t=${tokenString}`
    })
    .appendTo(toolbar)
}
